<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/photos">طلبات التصوير</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <PhotosForm v-if="!mainLoading && checkAccess('photos_orders_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :orderStatus="orderStatus" 
              :orderCancelAdmin="orderCancelAdmin" 
              :orderTypes="orderTypes" 
              :orderRejectReasons="orderRejectReasons" 
              :orderHoldReasons="orderHoldReasons" 
              :providerAcceptanceStatus="providerAcceptanceStatus" 
              :orderCancelClient="orderCancelClient" 
              :orderCancelProvider="orderCancelProvider" 
            />
            <PhotosView v-if="!mainLoading && !checkAccess('photos_orders_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :orderStatus="orderStatus" 
              :orderCancelAdmin="orderCancelAdmin" 
              :orderTypes="orderTypes" 
              :orderRejectReasons="orderRejectReasons" 
              :orderHoldReasons="orderHoldReasons" 
              :providerAcceptanceStatus="providerAcceptanceStatus" 
            />
            <AdminNotesPanel
              v-show="!mainLoading"
              modelName="MaintenanceOrders"
              :recordId="id"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import PhotosForm from './form.vue';
import PhotosView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'PhotosUpdate',
  components: {
    PhotosForm, PhotosView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل الطلب ',
      row: null,
      orderStatus: {},
      orderCancelAdmin: {},
      orderTypes: {},
      orderRejectReasons: {},
      orderHoldReasons: {},
      providerAcceptanceStatus: {},
      orderCancelClient: {},
      orderCancelProvider: {},
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/photos/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.rowTitle += `#${data.row.id}`;
        this.orderStatus = data.orderStatus;
        this.orderCancelAdmin = data.orderCancelAdmin;
        this.orderTypes = data.orderTypes;
        this.orderRejectReasons = data.orderRejectReasons;
        this.orderHoldReasons = data.orderHoldReasons;
        this.providerAcceptanceStatus = data.providerAcceptanceStatus;
        this.orderCancelClient = data.orderCancelClient;
        this.orderCancelProvider = data.orderCancelProvider;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
